import { FilterValue } from 'api/query/shared/filter-value';
import { SortDir } from 'pages/search/results/sort-dir.enum';
import { Action } from 'providers/action';
import React, {
  createContext, Dispatch, useContext, useReducer
} from 'react';
import { DisplayFormat } from 'shared/display-format.enum';
import { getFromStorage, StorageKey } from 'utils/storage-utils';
import { resultsReducer } from './results-reducer';
import { ResultsState } from './results-state';

type ResultsContext = {
  state: ResultsState,
  dispatch: Dispatch<Action>
};
const ResultsContext = createContext<ResultsContext>({} as ResultsContext);

const resultsInitialState = (): ResultsState => {
  const cachedDisplay = getFromStorage<FilterValue>(StorageKey.Display);
  const cachedTopPercentile = getFromStorage<FilterValue>(StorageKey.TopPercentile);
  const cachedBottomPercentile = getFromStorage<FilterValue>(StorageKey.BottomPercentile);

  const initialState: ResultsState = {
    customASBVs: [],
    display: cachedDisplay?.value || DisplayFormat.Data,
    topPercentile: cachedTopPercentile?.id || 3,
    bottomPercentile: cachedBottomPercentile?.id || 1,
    sortByASBV: { sortBy: '', sortDir: SortDir.BestToWorst },
  };

  return initialState;
};

export const ResultsProvider: React.FC = ({ children }): JSX.Element => {
  const [state, dispatch] = useReducer(resultsReducer, resultsInitialState());
  return (
    <ResultsContext.Provider value={{ state, dispatch }}>
      {children}
    </ResultsContext.Provider>
  );
};

// (ResultsProvider as any).whyDidYouRender = {
//   customName: 'ResultsProvider',
// };

export const useResultsContext = (): ResultsContext => {
  const context = useContext(ResultsContext);
  if (!context) {
    throw new Error('useResultsContext must be used within ResultsProvider');
  }
  return context;
};
